import { Star } from "lucide-react";
import { colors } from "@/theme";

export function StarRating({ rating = 0, count, size = 14, showCount = true }) {
  const full = Math.round(rating);
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          fill={i <= full ? colors.accentDark : "none"}
          color={i <= full ? colors.accentDark : colors.borderStrong}
          strokeWidth={1.5}
        />
      ))}
      {showCount && (
        <span className="font-body" style={{ fontSize: 12, color: colors.mutedText, marginLeft: 2 }}>
          {rating ? rating.toFixed(1) : "New"}{count != null ? ` (${count})` : ""}
        </span>
      )}
    </span>
  );
}
